var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMobileStatisticsIcon = function SvgMobileStatisticsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0781 16.6562H17.6719V8.53125C17.6719 8.42351 17.6291 8.32018 17.5529 8.24399C17.4767 8.1678 17.3734 8.125 17.2656 8.125H14.4219C14.3141 8.125 14.2108 8.1678 14.1346 8.24399C14.0584 8.32018 14.0156 8.42351 14.0156 8.53125V10.5625H11.5781C11.4704 10.5625 11.3671 10.6053 11.2909 10.6815C11.2147 10.7577 11.1719 10.861 11.1719 10.9687V13H8.73438C8.62663 13 8.5233 13.0428 8.44711 13.119C8.37093 13.1952 8.32813 13.2985 8.32812 13.4062V16.6562H7.92188C7.81413 16.6562 7.7108 16.699 7.63461 16.7752C7.55843 16.8514 7.51562 16.9548 7.51562 17.0625C7.51562 17.1702 7.55843 17.2736 7.63461 17.3498C7.7108 17.4259 7.81413 17.4687 7.92188 17.4687H18.0781C18.1859 17.4687 18.2892 17.4259 18.3654 17.3498C18.4416 17.2736 18.4844 17.1702 18.4844 17.0625C18.4844 16.9548 18.4416 16.8514 18.3654 16.7752C18.2892 16.699 18.1859 16.6562 18.0781 16.6562ZM11.9844 11.375H14.0156V16.6562H11.9844V11.375ZM9.14062 13.8125H11.1719V16.6562H9.14062V13.8125Z",
    fill: "#664CFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileStatisticsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MobileStatisticsIcon.a6ed3d8c.svg";
export { ForwardRef as ReactComponent };